/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_File_Tree_Select_AllInputs */

const es_components_file_tree_select_all = /** @type {(inputs: Components_File_Tree_Select_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar todo`)
};

const en_components_file_tree_select_all = /** @type {(inputs: Components_File_Tree_Select_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select all`)
};

/**
* | output |
* | --- |
* | "Select all" |
*
* @param {Components_File_Tree_Select_AllInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_file_tree_select_all = /** @type {((inputs?: Components_File_Tree_Select_AllInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_File_Tree_Select_AllInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_file_tree_select_all(inputs)
	return en_components_file_tree_select_all(inputs)
});
export { components_file_tree_select_all as "components.file_tree.select_all" }